module.exports = __webpack_public_path__ + "img/1e80e011f1b945a6877ee3794819b1f3.378aa914.jpg";